module.exports = __webpack_public_path__ + "static/img/spiralLogo.5a4a7c3a.png";